var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandIconVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40588 5.40588C4 6.81175 4 9.07448 4 13.5999V14.3999C4 18.9254 4 21.1881 5.40588 22.594C6.81175 23.9998 9.07448 23.9998 13.5999 23.9998H14.3999C18.9254 23.9998 21.1881 23.9998 22.594 22.594C23.9998 21.1881 23.9998 18.9254 23.9998 14.3999V13.5999C23.9998 9.07448 23.9998 6.81175 22.594 5.40588C21.1881 4 18.9254 4 14.3999 4H13.5999C9.07448 4 6.81175 4 5.40588 5.40588ZM7.33331 10.1249C7.44037 15.3274 10.173 18.4582 14.6771 18.4582H14.9384V15.4819C16.5788 15.6484 17.8021 16.8748 18.3014 18.4582H20.6665C20.0249 16.0895 18.3614 14.7799 17.3274 14.2796C18.3606 13.6608 19.8228 12.1606 20.1671 10.1249H18.0154C17.5639 11.7804 16.2208 13.2805 14.9376 13.423V10.1249H12.7515V15.899C11.4211 15.566 9.68562 13.9465 9.6145 10.1249H7.33331Z",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIconVk);
export default __webpack_public_path__ + "static/media/brand-icon_vk.1dd3e999e48e10277b1c425cd1df1c85.svg";
export { ForwardRef as ReactComponent };